
import React, { useRef } from 'react';

import { useCarContext } from '../components/Context/CarContext';
import { useSnackbar } from './SnackBar';
import { useProgressBar } from './ProgressBar';

const EngineForm= () => {
    const { AddEngine } = useCarContext();
    const { showSnackbar } = useSnackbar();
    const { showProgress } = useProgressBar();
    const engineRef = useRef(null);
    const oilRef= useRef(null);
    const formRef=useRef([]);
    const handleClick=()=>{
        const formElements=formRef.current.elements;
        for(let element of formElements){
            if(element.tagName==="INPUT" && element.type!=="BUTTON"){
                if(element.value===""){
                    element.style.borderColor='red';
                }else{
                    element.style.borderColor='';
                }
            }
            
        }
    }
    const emptyFieldCheck=(e)=>{
        if(e.target.valu===""){
            e.target.style.borderColor=''
        }else{
            e.target.style.borderColor='';
        }
    }
    const handleAddEngine = async () => {
        if (engineRef.current.value.trim() === '' && oilRef.current.value.trim() === '') {
            showSnackbar('Engine Class cannot be blank', 'error');
            handleClick();
            return;
        }
        showProgress(true);
        await AddEngine({ id: 0, name: engineRef.current.value.trim(), oilQuantity: oilRef.current.value.trim() });
        showProgress(false);
        showSnackbar('This is a test message', 'warning');
    };

    return (

        <form ref={formRef}>
            <div className="row mb-3">
                <label htmlFor="icon" className="col-sm-2 col-form-label">Engine Class</label>
                <div className="col-sm-10">
                    <input type="text" ref={engineRef}  className="form-control" onBlur={(e)=>{ emptyFieldCheck(e);  }}/>
                </div>
            </div>

            <div className="row mb-3">
                <label htmlFor="icon" className="col-sm-2 col-form-label">Oil Quantity</label>
                <div className="col-sm-10">
                    <input type="text" ref={oilRef}  className="form-control" onBlur={(e)=>{ emptyFieldCheck(e);  }}/>
                </div>

            </div>

            <div className="text-left">
                <label htmlFor="icon" className="col-sm-2 col-form-label"></label>
                <button type="button" onClick={handleAddEngine} className="btn btn-primary">Save</button>

            </div>

        </form>


    );
};


export default EngineForm;
